// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__0Agi8","href":"Breadcrumb_href__Toawd"};